module.exports = __webpack_public_path__ + "img/fourth.86068714.png";